import angular from 'angular';

module.exports = angular.module('market.routes.vendor_help.current', [])
.config(function($stateProvider) {
  $stateProvider.state('vendor_help.current', {
    url: '/current',
    template: require('./current.jade')(),
  });
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/market/routes/vendor-help/current.js
 **/